// material-ui
import { Box, FormControl, OutlinedInput, InputLabel, MenuItem, ListItemText, Select, Checkbox } from '@mui/material';
import { SINGLE_OUTLET_MENU_LIST } from 'constants/index';

// assets
import { useLang } from 'hooks/common/lang';
import { useSelectedShopId } from 'hooks/common/selectedShopId';
import { matchPath, useLocation } from 'react-router';

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP + (ITEM_HEIGHT / 2 + 4),
            width: 250
        }
    }
};

const Search = () => {
    const { $t } = useLang();
    const { shopList, selectedShopId, selectedShopIds, selectedShops, handleChangeShopIds } = useSelectedShopId();

    const location = useLocation();

    const isSingleOutlet = SINGLE_OUTLET_MENU_LIST.some((path) => matchPath(path, location.pathname));

    const handleChange = (shopIds) => {
        if (!isSingleOutlet && shopIds.indexOf('-1') >= 0) {
            if (selectedShopIds.length === shopList.length) {
                handleChangeShopIds(shopList[0].id);
            } else {
                handleChangeShopIds(shopList.map((shop) => shop.id));
            }

            return;
        }

        if (!isSingleOutlet && shopIds.length === 0) {
            handleChangeShopIds(selectedShopIds);
            return;
        }

        handleChangeShopIds(shopIds);
    };

    return (
        <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="outlet">Outlet</InputLabel>

                <Select
                    labelId="outlet"
                    id="outlet"
                    multiple={!isSingleOutlet}
                    value={isSingleOutlet ? selectedShopId : selectedShopIds}
                    onChange={(e) => handleChange(e.target.value)}
                    input={<OutlinedInput label="Tag" />}
                    renderValue={isSingleOutlet ? undefined : () => selectedShops.map((shop) => shop.name).join(', ')}
                    MenuProps={MenuProps}
                    sx={{ height: '48px' }}
                >
                    {!isSingleOutlet && (
                        <MenuItem value="-1" selected={selectedShopIds.length === shopList.length}>
                            <Checkbox checked={selectedShopIds.length === shopList.length} />
                            <ListItemText primary={$t('general.OpAllOutlet')} />
                        </MenuItem>
                    )}

                    {shopList.map((shop) => (
                        <MenuItem key={shop.id} value={shop.id} sx={{ height: '54px' }}>
                            {!isSingleOutlet && <Checkbox checked={selectedShopIds.indexOf(shop.id) > -1} />}
                            <ListItemText primary={shop.name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default Search;
